import AdminList from "@/admin/components/AdminList";

export default function CityList() {
  return (
    <AdminList
      testId="admin-cities-list"
      title="Cidades"
      kicker="Gestão de Conteúdo"
      resource="cities"
      createTo="/admin/cidades/nova"
      editTo="/admin/cidades"
      columns={[
        {
          key: "name", label: "Cidade",
          render: (c) => (
            <div className="flex items-center gap-3">
              {c.cover_image && <img src={c.cover_image} className="w-12 h-12 rounded-lg object-cover border border-[#2a2a2a]" alt="" />}
              <div><div className="text-white font-medium">{c.name}</div><div className="text-[10px] tracking-[0.2em] uppercase text-[#7d7d7d] mt-0.5">{c.slug}</div></div>
            </div>
          ),
        },
        { key: "state", label: "Estado" },
      ]}
    />
  );
}
